import { logger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

export const otaLogger = logger.extend('OTA');
logger.enable('OTA');
